// extracted by mini-css-extract-plugin
export default {"dropdown":"kitchenplan_dropdown__-0+NJ"};